import { Faq } from "@Components/faq/Faq";
import CmsPage, { getCMSPageModel } from "@Libs/contentful/components/CmsPage";
import FAQPage from "@Libs/contentful/queries/FAQPage";
import { pageModel } from "@Types/Contentful";
import { getStaticPaths, makeStaticProps } from "@wff/libs/i18n/getStatic";

interface FaqPageProps {
  pageModel: pageModel;
}

const FaqPage = ({ pageModel }: FaqPageProps) => {
  const { pageContent = {} } = pageModel;

  return (
    <CmsPage
      pageModel={pageModel}
      pageTitle={pageContent.pageTitle}
      pageDescription={pageContent.pageDescription}
    >
      <Faq {...pageContent} pageTitle={pageContent.pageTitle} />
    </CmsPage>
  );
};

const overrideStaticProps = async (props: any) => {
  const { locale } = props;

  const pageModel = await getCMSPageModel(FAQPage, {
    locale,
  });

  return {
    props: {
      pageModel,
    },
    revalidate: 10, // TODO:- Set revalidation timeout based on the Architecture discussion
  };
};

const getStaticProps = makeStaticProps(["common"], overrideStaticProps);
export { getStaticPaths, getStaticProps };

export default FaqPage;
